import api from "./axiosInterceptor";

export const getSectors = () => api.get("trends/sector-industry");

export const getIndustries = (id) => api.get(`/trends/sector/${id}/industies`);

export const getArticles = () => api.get("fmp/articles");
